import $ from "jquery";
import flatpickr from "flatpickr";

import "flatpickr/dist/l10n/cs.js";

$(document).ready(function () {
    $(".input-date__control").flatpickr({
        enableTime: false,
        altInput: true,
        dateFormat: "Y-m-d",
        altFormat: "d.m.Y",
        time_24hr: true,
        locale: "cs"
    });

    $(".input-date-range__control").flatpickr({
        mode: "range",
        enableTime: false,
        altInput: true,
        dateFormat: "Y-m-d",
        altFormat: "d.m.Y",
        time_24hr: true,
        locale: "cs"
    });

    $(".input-date-time__control").flatpickr({
        enableTime: true,
        altInput: true,
        dateFormat: "Y-m-d H:i",
        altFormat: "d.m.Y H:i",
        time_24hr: true,
        locale: "cs"
    });

    $(".input-date-time-range__control").flatpickr({
        mode: "range",
        enableTime: true,
        altInput: true,
        dateFormat: "Y-m-d H:i",
        altFormat: "d.m.Y H:i",
        time_24hr: true,
        locale: "cs"
    });

    $(".input-time__control").flatpickr({
        enableTime: true,
        noCalendar: true,
        altInput: true,
        dateFormat: "H:i",
        altFormat: "H:i",
        time_24hr: true,
        locale: "cs"
    });

    $(".input-time-range__control").flatpickr({
        mode: "range",
        enableTime: true,
        noCalendar: true,
        altInput: true,
        dateFormat: "H:i",
        altFormat: "H:i",
        time_24hr: true,
        locale: "cs"
    });
});  